module.exports = __webpack_public_path__ + "static/media/i.5b60e3bd.svg";